import React from  'react';
import './projects.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
const Projects = ({img, title, desc, live, code}) =>{
        useEffect(()=>{
          Aos.init({
            duration: 2000,
           });
         },[]);
    return(
        <div className='projects' id='project' data-aos= 'fade-right'>
        <div className='projects__items'>
         <div className='projects__image'>
             <img src= {img} alt='project__images' />
         </div>
        <div className='projects__desc'>
        <h5>{title}</h5>
          <p>{desc}</p>
          <div className='projects__buttons'>
          <a href={live} target='_blank' rel="noopener noreferrer">Live Demo</a>
          
          </div>
        </div>
         
        </div>
        </div>
    );
}

export default Projects;